<template>
  <div>

    <BackButton v-if="$route.name !== 'zones'" :namedRoutes="{ zones: $t('nav.zones'), zone: $t('common.zone')}"></BackButton>

    <add-zone-view v-if="$route.name === 'edit-zone' || $route.name === 'add-zone'" />
    <zone-details @isDeleted="(boolean) => {isDetailDeleted = boolean}" v-if="$route.name === 'zone'" />
    <products-table v-if="!isDetailDeleted && $route.name === 'zone'" />

    <BackButton v-if="$route.name !== 'zones'" :namedRoutes="{ zones: $t('nav.zones'), zone: $t('common.zone')}"></BackButton>

  </div>
</template>

<script>
import BackButton from 'common/BackButton';
import ZoneDetails from './ZoneDetails';
import ProductsTable from './ProductsTable';
import AddZoneView from './AddZoneView';

export default {
  components: {
    BackButton,
    ZoneDetails,
    ProductsTable,
    AddZoneView,
  },
  data() {
    return {
      isDetailDeleted: false,
    };
  },
  route: {
    canReuse: true,
    isDetailDeleted: false,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/zones/MainView.vue